module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2020_02.596e7e9b.jpg";